<template>
  <div
    class="animate-pulse text-white text-xl font-bold flex flex-col justify-center items-center"
  >
    <div class="mb-5"><IconLoading /></div>
    <div>{{ messageQueue[intervalId] }}</div>
  </div>
</template>

<script>
import IconLoading from "@/assets/icons/IconLoading.vue";
export default {
  name: "loading-page",
  components: {
    IconLoading
  },
  data() {
    return { intervalTimer: null, intervalId: 0 };
  },
  props: {
    loadings: {
      type: Array,
      required: true
    }
  },
  computed: {
    progress() {
      let completed = this.loadings.filter((loading) => !loading.value);
      return completed.length / this.loadings.length;
    },
    messageQueue() {
      let result = [
        "Synchronizing star charts... er, databases. 🛰️ Hold tight, cosmic alignment in progress!",
        "This operation occurs once every 24 hours per region—just like a solar rotation! ☀️ See you in the next orbit! 🛰️",
        "Flushing cosmic dust from the cache... 🪐 This may cause minor temporal distortions!",
        "Engaging warp drive for faster processing! 🏎️💨 Destination: Content Management Nebula!"
      ];
      this.loadings.forEach((loading) => {
        if (!result.includes(loading.message) && !loading.value) {
          result.push(loading.message);
        }
      });
      return result;
    }
  },
  mounted() {
    let num = 0;
    this.intervalTimer = setInterval(() => {
      num = (num + 1) % this.messageQueue.length;
      this.intervalId = num;
    }, 4500);
  },
  unmounted() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  },
  watch: {
    loadings() {
      this.loadings.forEach((loading) => {
        if (!this.messageQueue.includes(loading.message) && !loading.value) {
          this.messageQueue.push(loading.message);
        }
      });
    }
  }
};
</script>
